import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/detail/:id',
      name: 'detail',
      component: () => import('./views/Detail.vue')
    },
    {
      path: '/guide',
      name: 'guide',
      component: () => import('./views/Guide.vue')
    },
    {
      path: '/covid',
      name: 'covid',
      component: () => import('./views/Covid.vue')
    },
    {
      path: '/nida',
      name: 'nida',
      component: () => import('./views/NIDA.vue')
    },
    {
      path: '/share',
      name: 'share',
      component: () => import('./views/Share.vue')
    },
    {
      path: '/other-resources',
      name: 'other-resources',
      component: () => import('./views/Other-resources.vue')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    const position = {};

    if(savedPosition){
      position.x = savedPosition.x;
      position.y = savedPosition.y;
    }

    if(to.name === 'home'){
      return new Promise((resolve, reject) => {
        this.app.$root.$once('resourcesLoaded', () => {
          resolve(position);
        })
      });
    } else {
      return {x: 0, y: 0};
    }

  }
})
